module.exports = __webpack_public_path__ + "static/sadeq-720ae3cb0336ef4ea7e4f982cc37a6ec.png";